const escapeCsvCell = (value: string): string => `"${value.replaceAll(`"`, `""`)}"`;

/**
 * Turns a matrix of pre-stringified cells (first row = header) into CSV text.
 * Every cell is quoted and embedded quotes are doubled, so commas / quotes /
 * newlines inside values are safe.
 */
const toCsv = (rows: string[][]): string =>
  rows.map((row) => row.map(escapeCsvCell).join(",")).join("\n");

export default toCsv;
